// @flow
import {
  TREE,
} from '../constants'

// Utils
import traverse from 'fc-utils/traverse'

export default (traverse([TREE, 'authenticatedUser']): number)
